const locales = [
  'ar-AE',
  'da-DK',
  'de-DE',
  'de-AT',
  'de-CH',
  'en-AU',
  'en-GB',
  'en-IE',
  'en-US',
  'es-ES',
  'fi-FI',
  'fr-FR', // not currently present at polestar.com
  'fr-BE',
  'fr-CA',
  'fr-CH',
  'fr-LU',
  'is-IS',
  'it-IT',
  'it-CH',
  'ko-KR',
  'nl-NL',
  'nl-BE',
  'no-NO',
  'pt-PT',
  'sv-SE',
  'zh-CN',
];

const languageToLocale = {
  en: 'en-GB',
  de: 'de-DE',
  fr: 'fr-FR',
  it: 'it-IT',
  pt: 'pt-PT',
  zh: 'zh-CN',
};

module.exports = {
  locales,
  languageToLocale,
};
